import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Flex } from "grid-styled";

import withTracker from "../withTracker";

import BookListPage from "../../pages/BookListPage";

const App = () => {
    return (
        <Flex flexDirection="column" flex={1} style={{ minHeight: 0 }}>
            <Router>
                <Switch>
                    <Route
                        exact
                        path="/"
                        component={withTracker(BookListPage)}
                    />
                </Switch>
            </Router>
        </Flex>
    );
};
export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js